// Privacy Statement (GDPR-compliant, English)
// --------------------------------------------
//
// Wave 14bs: Muss auf der Signup-Seite akzeptiert werden.
// Deutsch-sprachiger Inhaber mit EU-Usern → GDPR (DSGVO) greift.
// Kein User kann signed-up werden ohne Checkbox-Bestätigung.
//
// Der Text ist bewusst knapp und in Plain-English. Keine Schachtelsätze,
// keine juristischen Floskeln — was der User wirklich wissen muss.
//
// Wichtigste Claims:
//   - Wir speichern NUR Vorname, Nachname, Email.
//   - KEIN Routen-Tracking auf Server. GPS-Daten bleiben auf dem Gerät.
//   - Session-Metadaten (last-seen, Dauer) sichtbar für Admin.
//   - Recht auf Löschung, Auskunft, Datenexport (GDPR Art. 15-17).
//   - Datenstandort EU.

export function PrivacyStatement() {
  return (
    <div className="space-y-3">
      <section>
        <h3 className="font-semibold text-white mb-1">Who runs this app</h3>
        <p>
          All Day Turbo ULTRA is an early-access ultra-distance cycling companion
          app. This
          privacy statement describes what personal data we collect, why, and
          what rights you have under the EU General Data Protection Regulation
          (GDPR).
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-white mb-1">What we store</h3>
        <p>The only personal data we keep on our servers is:</p>
        <ul className="list-disc pl-5 space-y-1 mt-1">
          <li>Your first name, last name, and email address.</li>
          <li>Your invite code and when you used it.</li>
          <li>
            Session metadata: when you last opened the app, total time spent in
            the app, and the type of device you signed in on (for example
            &ldquo;iPhone — Safari&rdquo;). This is used to cap active devices
            at two per account and so that we can tell if an account is still
            in use.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="font-semibold text-white mb-1">What we do NOT store</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <strong>No routes, no GPS tracks.</strong> Your riding data stays
            on your device. We do not upload tracks to a server.
          </li>
          <li>No payment information — the app is free during early access.</li>
          <li>No contacts, photos, or files from your device.</li>
          <li>
            No advertising identifiers, no third-party analytics, no marketing
            cookies.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="font-semibold text-white mb-1">Who can see your data</h3>
        <p>
          Only the app operator can see the list of registered users and the
          session metadata described above. We do not sell, rent, or share your
          personal data with third parties. Data is stored on servers located
          in the European Union.
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-white mb-1">Email</h3>
        <p>
          We use your email address only to send you sign-in links ("magic
          links"). You will not receive marketing emails. Sign-in links expire
          after 15 minutes and can each be used only once.
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-white mb-1">Your rights (GDPR)</h3>
        <p>
          You have the right to access your data (Art. 15), to correct it
          (Art. 16), to have it deleted (Art. 17), to restrict processing
          (Art. 18), and to data portability (Art. 20). To exercise these
          rights, reply to any magic-link email from us and we will respond
          within 30 days.
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-white mb-1">Cookies &amp; local storage</h3>
        <p>
          We use a single session cookie to keep you signed in, and your
          browser&apos;s local storage to cache offline maps. We do not use
          tracking cookies.
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-white mb-1">Changes</h3>
        <p>
          This statement may evolve as the app grows. If something material
          changes, we will ask you to accept the new version before signing in
          again.
        </p>
      </section>
    </div>
  );
}
